import styled from "@emotion/styled";
import { useContext, useMemo } from "react";
import { MainContext } from "../../../context/main-context";
import { EmptyState } from "../../common/empty-state";
import { Container } from "../common/styles";
import { CheckoutList } from "./checkout-list";
import { PreviewList } from "./preview-list";
import { useTranslation } from 'react-i18next'

const Columns = styled.div({
  display: "flex",
  justifyContent: "flex-start",
  width: "100%",
  overflowY: "hidden",
});

export const Conditions = () => {
  const {
    statusCheckout,
    isLoadingCheckout,
    checkout,
    paymentMethods,
    enrollment,
  } = useContext(MainContext);
  const { t } = useTranslation()

  const isEmpty = useMemo(() => {
    return (
      !checkout?.code ||
      (paymentMethods.length === 0 && enrollment.length === 0)
    );
  }, [checkout, paymentMethods, enrollment]);

  if (isLoadingCheckout && statusCheckout !== "success") return null;

  return (
    <>
      {isEmpty && !isLoadingCheckout ? (
        <Container>
          <EmptyState
            title={t('emptyTitle')}
            description={t('emptyBody')}
            link="/routing"
          />
        </Container>
      ) : (
        <Columns>
          <CheckoutList isLoading={isLoadingCheckout} />
          {!isLoadingCheckout && <PreviewList />}
        </Columns>
      )}
    </>
  );
};
